import React, { createContext, useState, useCallback } from 'react';

export const SucursalContext = createContext();

function leerSucursalGuardada() {
  try {
    const stored = localStorage.getItem('sucursalSeleccionada');
    return stored ? JSON.parse(stored) : null;
  } catch {
    return null;
  }
}

export const SucursalProvider = ({ children }) => {
  // Inicializar desde localStorage en el primer render (evita un frame con sucursal null y /home colgado).
  const [sucursal, setSucursal] = useState(leerSucursalGuardada);

  const seleccionarSucursal = useCallback((suc) => {
    setSucursal(suc);
    localStorage.setItem('sucursalSeleccionada', JSON.stringify(suc));
  }, []);

  const limpiarSucursal = () => {
    setSucursal(null);
    localStorage.removeItem('sucursalSeleccionada');
  };

  return (
    <SucursalContext.Provider value={{ sucursal, seleccionarSucursal, limpiarSucursal }}>
      {children}
    </SucursalContext.Provider>
  );
};